import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"

export function useGetMyLicenses() {
  return useSuspenseQueryGet("/api/User/GetMyLicenses", null)
}
